"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Logo = require("./Logo.types");
var _messages = require("./messages");
var _i18n = require("../i18n");
var _theming = require("../theming");
var _excluded = ["product", "variant", "kind", "alt", "href"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var getImageSrc = function getImageSrc(_ref) {
  var product = _ref.product,
    locale = _ref.locale,
    variant = _ref.variant,
    kind = _ref.kind;
  var DOMAIN = 'https://cozy-assets.quintoandar.com.br';
  var PACKAGE = 'cozy-static';
  var COZY_STATIC_MAJOR_VERSION = 'v3';
  var THEME = product === _Logo.Product.INMUEBLES24 ? _theming.Theme.INMUEBLES24 : 'default';
  var COMPONENT = 'logo';
  return "".concat(DOMAIN, "/").concat(PACKAGE, "/").concat(COZY_STATIC_MAJOR_VERSION, "/latest/").concat(THEME, "/").concat(COMPONENT, "/").concat(product, "/").concat(kind, "/").concat(variant, ".").concat(locale, ".svg");
};
var getAltMessageByVariant = function getAltMessageByVariant(product, variant) {
  var _mapper;
  var message = (0, _messages.getMessage)(product);
  var mapper = (_mapper = {}, _defineProperty(_mapper, _Logo.Variant.COMPLETE, message.altComplete), _defineProperty(_mapper, _Logo.Variant.SYMBOL, message.altSymbol), _defineProperty(_mapper, _Logo.Variant.WORDMARK, message.altWordmark), _mapper);
  return mapper[variant];
};
var getImageSizes = function getImageSizes(product, variant) {
  var _Product$QUINTOANDAR, _Product$INMUEBLES, _sizes;
  var sizes = (_sizes = {}, _defineProperty(_sizes, _Logo.Product.QUINTOANDAR, (_Product$QUINTOANDAR = {}, _defineProperty(_Product$QUINTOANDAR, _Logo.Variant.SYMBOL, {
    height: '24px',
    width: '24px'
  }), _defineProperty(_Product$QUINTOANDAR, _Logo.Variant.COMPLETE, {
    height: '24px',
    width: '184px'
  }), _defineProperty(_Product$QUINTOANDAR, _Logo.Variant.WORDMARK, {
    height: '24px',
    width: '153px'
  }), _Product$QUINTOANDAR)), _defineProperty(_sizes, _Logo.Product.INMUEBLES24, (_Product$INMUEBLES = {}, _defineProperty(_Product$INMUEBLES, _Logo.Variant.SYMBOL, {
    height: '32px',
    width: '32px'
  }), _defineProperty(_Product$INMUEBLES, _Logo.Variant.COMPLETE, {
    height: '32px',
    width: '184px'
  }), _defineProperty(_Product$INMUEBLES, _Logo.Variant.WORDMARK, {
    height: '32px',
    width: '153px'
  }), _Product$INMUEBLES)), _sizes);
  return sizes[product][variant];
};
var Logo = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var product = _ref2.product,
    variant = _ref2.variant,
    kind = _ref2.kind,
    alt = _ref2.alt,
    href = _ref2.href,
    props = _objectWithoutProperties(_ref2, _excluded);
  var locale = (0, _i18n.getLocale)();
  var _useIntl = (0, _reactIntl.useIntl)(),
    formatMessage = _useIntl.formatMessage;
  var imageAlt = alt || formatMessage(getAltMessageByVariant(product, variant));
  var imageSrc = getImageSrc({
    product: product,
    locale: locale,
    variant: variant,
    kind: kind
  });
  var _getImageSizes = getImageSizes(product, variant),
    height = _getImageSizes.height,
    width = _getImageSizes.width;
  if (href) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: href
    }, /*#__PURE__*/_react["default"].createElement("img", _extends({
      alt: imageAlt,
      ref: ref,
      className: "Cozy__Logo",
      fetchpriority: "high",
      src: imageSrc,
      height: height,
      width: width
    }, props)));
  }
  return /*#__PURE__*/_react["default"].createElement("img", _extends({
    alt: imageAlt,
    ref: ref,
    className: "Cozy__Logo",
    fetchpriority: "high",
    src: imageSrc,
    height: height,
    width: width
  }, props));
});
Logo.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(Object.values(_Logo.Kind)),
  product: _propTypes["default"].oneOf(Object.values(_Logo.Product)),
  variant: _propTypes["default"].oneOf(Object.values(_Logo.Variant)),
  fetchpriority: _propTypes["default"].oneOf(['high', 'low', 'auto']),
  alt: _propTypes["default"].string,
  href: _propTypes["default"].string
} : {};
Logo.defaultProps = {
  kind: _Logo.Kind.DEFAULT,
  product: _Logo.Product.QUINTOANDAR,
  variant: _Logo.Variant.COMPLETE,
  fetchpriority: 'high',
  alt: '',
  href: null
};
var _default = exports["default"] = Logo;